import AttributesListPanel from './attributesListPanel.container';

export default AttributesListPanel